import { Size, Scale, CreateElement, LogGroup } from "../../MyHelpers";
import { SlotSymbolSprite } from "../SlotSymbolSprite";
import { MyCanvas } from "../MyCanvas";
import { SlotSymbol } from "../SlotSymbol";
import { SlotGameMessages } from "../SlotGameScreenMessages";
import { IPaytable } from "./IPayTable";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, ResourceManager } from "../../ResourceManager/ResourceManager";
import { DecodedImageResource, ImageResource } from "../../ResourceManager/ImageResource";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { IPaytableParams } from "./IPayTableFactory";
import { Settings } from "../../Settings";
import { CanvasSprite } from "../Sprite/CanvasSprite";
import { PixiSpriteResource } from "../../ResourceManager/PixiSpriteResource";
import { IRandomInterval } from "../../Context/RandomInterval";
import { ISystemContext } from "../../Context/SystemContext";
import { BonusConfigurationList } from "../../SlotGameInitData";
import { IGroupedSimplePaytableData } from "./PayTable8Squares";
import { Translator } from "../../Translator";
import { IPublicSimpleBonusTrigger, PlayWindow, Symbol } from "../../api";
import { WildBulkSlide, WildBulkSlidePaytableParams } from "./slides/WildBulkSlide";
import { SymbolsCollectionResources } from "../SpineSymbols/SymbolsCollection";
import { SymbolType } from "../../../singlegame/singlegame_api";

export interface WinsMap {
	symbolType: SymbolType;
	groupName: string;
	payIndex: number;
	winElement: HTMLElement;
}

export class PayTable9Squares implements IPaytable {
	protected symbolSize: Size = new Size(Scale.W(400), Scale.H(350));
	protected paytable: IGroupedSimplePaytableData;
	// //USE FOR COUNT SYMBOLS IN OTHERS PAYTABLE
	protected numerSymbols: number = null;
	protected numberGroups: number = 0;
	protected NameGroups: string[];
	protected slotSymbolsData: SlotSymbol[];


	protected view: HTMLElement = null;
	//protected symbolSpriteAnims: SlotSymbolSprite[] = [];
	//protected canvas: MyCanvas[] = [];
	protected viewSize: Size;
	protected winsToUpdate: WinsMap[] = [];
	protected nameGame: string;
	protected basepath: string;
	//Create title Sprite 
	protected titleSprite: HTMLElement = null;
	protected resid: ResourceIdentifier;
	protected logGroup: LogGroup = new LogGroup("PayTable8Squares");
	// protected titleStartTimer: IRandomInterval;
	protected systemContext: ISystemContext;
	protected bonusConfiguration: BonusConfigurationList = null;
	protected bonusTrigger: IPublicSimpleBonusTrigger[] = null;
	protected translator: Translator = null;
	protected wildInReel: number[] = [];
	protected wildSymbol: Symbol = null;
	//create wildSlide 
	protected wildBulkSlide: WildBulkSlide = null;
	protected playWindow: PlayWindow = null;
	protected playlines: number[][] = [];
	protected scattersTrigger : string [] = [];
	readonly symbolsCollection : Map<string,SymbolsCollectionResources> = null;
	constructor(paytable: IGroupedSimplePaytableData, paytableParams: IPaytableParams) {
		this.symbolsCollection = paytableParams.symbolsCollection;
		this.viewSize = paytableParams.viewSize;
		this.paytable = paytable;
		//this.symbolSpriteAnims = paytableParams.symbolSpriteAnims;
		this.nameGame = paytableParams.nameGame;
		this.basepath = Settings.ResourcesFolder + "multigame/slot/" + this.nameGame + "/";
		this.resid = paytableParams.resid;
		this.systemContext = paytableParams.systemContext.CreateSubContext("paytable8Squares");
		this.bonusConfiguration = paytableParams.initData.BonusConfiguration;
		this.translator = paytableParams.translator;
		this.bonusTrigger = paytableParams.initData.BonusTriggers;
		this.scattersTrigger = paytableParams.symbols.filter(s=>s.SymbolType == "Scatter").flatMap(s=>s.ID)
		this.playWindow = paytableParams.initData.PlayWindow;


		this.view = CreateElement("div", {
			classes: ["paytable"],
			style: {
				width: Scale.Wpx(1920),
				height: Scale.Hpx(1080),
				display: "flex",
				alignContent: "center",
				flexDirection: "column",
				flexWrap: "wrap",
			}
		});


		//console.log(`InitData:${paytableParams.initData.Name}`,paytableParams.symbols.filter(s=>s.SymbolType == "Scatter").flatMap(s=>s.ID));
		this.slotSymbolsData = paytableParams.symbols;
		this.NameGroups = Object.keys(this.paytable.Groups);
		this.playlines = paytableParams.initData.Playlines;
		this.wildSymbol = paytableParams.initData.Symbols.find(symbol => symbol.ID == "Wild" && symbol.IsWild == true);
		if (this.wildSymbol) {
			for (let reel = 0; reel < paytableParams.initData.ReelSet.length; reel++) {
				for (let row = 0; row < paytableParams.initData.ReelSet[reel].length; row++) {
					if (paytableParams.initData.ReelSet[reel][row] == this.wildSymbol.Index) {
						this.wildInReel.push(reel+1);
						break
					}
				}
			}
		}

		
	}
	OnResize(): void {
		throw new Error("Method not implemented.");
	}
	Build(): void {
		throw new Error("Method not implemented.");
	}

	public async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void> {
		resourceManager.AddGlobal(new ImageResource(this.basepath + "resources/PayTable8Squares-Left.png", ResourceIdentifier.Global.Add([this.nameGame, "paytable", "background-left"]).Scope()));
		resourceManager.AddGlobal(new ImageResource(this.basepath + "resources/PayTable8Squares-Right.png", ResourceIdentifier.Global.Add([this.nameGame, "paytable", "background-right"]).Scope()));
		resourceManager.AddGlobal(new ImageResource(this.basepath + "resources/PayTable8Squares-Center.png", ResourceIdentifier.Global.Add([this.nameGame, "paytable", "background-center"]).Scope()));
		//resourceManager.AddGlobal(new ImageResource(this.basepath + "resources/title.png", ResourceIdentifier.Global.Add([this.nameGame, "paytableTitle", "background"]).Scope()));
		// resourceManager.AddGlobal(new PixiSpriteResource(this.basepath + "resources/title_sprite2", ResourceIdentifier.Global.Add(this.nameGame).Add("titlePaytable"), true, this.logGroup.Add("titlePaytable"), true));
		resourceManager.AddGlobal(new ImageResource(this.basepath + "resources/title.png", ResourceIdentifier.Global.Add([this.nameGame, "paytableTitle"]).Scope()));
		resourceManager.AddGlobal(new ImageResource(Settings.ResourcesFolder + "multigame/slot/common/resources/TitleFeaturesPaytable/scatter.png", ResourceIdentifier.Global.Add(["paytableTitle", "scatter"]).Scope()));
		resourceManager.AddGlobal(new ImageResource(Settings.ResourcesFolder + "multigame/slot/common/resources/TitleFeaturesPaytable/wild.png", ResourceIdentifier.Global.Add(["paytableTitle", "wild"]).Scope()));
	}

	public async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {
		this.BuildPaytable(resourceManager);
	}
	protected BuildPaytable(resourceManager: IReadOnlyResourceManager): void {
		let columnsGroups: HTMLElement[] = [];

		//create title container 
		let containerTitle = CreateElement("div", {
			classes: ["paytable-title-container"],
			style: {
				width: "100%",
				height: "12%",
				alignItems: "center",
				justifyContent: "center",
				display: "flex",
				position: "relative",
				// top: Scale.Ypx(73),
			}
		});

		//create title sprite 		
		// this.titleSprite = new CanvasSprite({
		// 	sprite: resourceManager.Get<DecodedImageResource>(ResourceIdentifier.Global.Add([this.nameGame, "paytableTitle"]).Scope()).DecodedImage(),
		// 	canvasSize: new Size(Scale.W(700), Scale.H(340))
		// });
		this.titleSprite = resourceManager.Get<ImageResource>(ResourceIdentifier.Global.Add([this.nameGame, "paytableTitle"]).Scope()).img.cloneNode(true) as HTMLElement;
		this.titleSprite.style.width = Scale.Wpx(700);
		this.titleSprite.style.position = "absolute";
		this.titleSprite.style.top = "0px";
		// this.titleSprite.style.height = Scale.Hpx(340);

		//Create Some interval 
		// this.titleStartTimer = this.systemContext.TimingContext().CreateRandomInterval("titleStartTimer", 5000, 10000, () => this.titleSprite.Start(false));
		//Paytable COntainer		
		let paytableSymbolsContainer = CreateElement("div", {
			classes: ["paytable-symbols-container"],
			//parentToAppend: this.view,
			style: {
				display: "flex",
				flexDirection: "column",
				flexWrap: "wrap",
				justifyContent: "center",
				width: "100%",
				height: "88%",
				alignItems: "center",
				transform: "scale(0.9)",
				position: "relative",
				// top: Scale.Ypx(0),
			}
		});

		let GroupPerColumn = 0;
		let symbol_number = 0;
		let IndexGroup = 0;

		//Create 3 columns 		
		for (let columnIndex = 0; columnIndex < 3; columnIndex++) {
			let paytableSymbolsContainerColumn = CreateElement("div", {
				classes: ["paytable-symbols-container-column-" + columnIndex],
				parentToAppend: paytableSymbolsContainer,
				style: {
					display: "flex",
					flexDirection: "column",
					justifyContent: "center",
					height: "100%",
					position: "relative",
					alignContent: "center",
					alignItems: "center",
					// placeContent: "center",
					// gap: Scale.Ypx(60),
				}
			});
			if (columnIndex == 1) {
				// paytableSymbolsContainerColumn.style.top = Scale.Ypx(75);
			}
			//add groups for array for use later 
			columnsGroups.push(paytableSymbolsContainerColumn);
		}


		let groupCountCenter = this.NameGroups.filter((group) => {
			return group.includes("Center");
		});

		if (groupCountCenter.length <= 2) {
			columnsGroups[1].appendChild(this.titleSprite);
		} else {
			this.view.appendChild(containerTitle);
			containerTitle.appendChild(this.titleSprite);
		}


		//Create Groups 
		for (let groupIndex = 0; groupIndex < this.NameGroups.length; groupIndex++) {

			//create some fater container for move all container dont worry position 
			let mainSymbolContainer = CreateElement("div", {
				classes: ["symbol-container", `${this.NameGroups[groupIndex]}`],
				style: {
					display: "flex",
					position: "relative",
					justifyContent: "center",
					alignItems: "center",
				}
			});

			if (this.NameGroups[groupIndex] == "TopLeft" || this.NameGroups[groupIndex] == "MiddleLeft" || this.NameGroups[groupIndex] == "BottomLeft") {
				columnsGroups[0].appendChild(mainSymbolContainer);
			}
			else if (this.NameGroups[groupIndex] == "TopCenter" || this.NameGroups[groupIndex] == "MiddleCenter" || this.NameGroups[groupIndex] == "BottomCenter") {
				mainSymbolContainer.style.width = Scale.Wpx(700);
				mainSymbolContainer.style.height = Scale.Hpx(250);
				columnsGroups[1].appendChild(mainSymbolContainer);
			}
			else if (this.NameGroups[groupIndex] == "TopRight" || this.NameGroups[groupIndex] == "MiddleRight" || this.NameGroups[groupIndex] == "BottomRight") {
				columnsGroups[2].appendChild(mainSymbolContainer);
			}

			let symbolName: string[] = this.paytable.Groups[this.NameGroups[IndexGroup]].Symbols;
			let slotSymbol: SlotSymbol = this.slotSymbolsData.find(symbol => symbol.ID == symbolName[0]);
			//symbols container and background img
			let symbolContainer = CreateElement("div", {
				classes: ["paytable-symbol-container"],
				parentToAppend: mainSymbolContainer,
				style: {
					display: "flex",
					flexDirection: "column",
					flexWrap: "wrap",
					width: Scale.W(590) + "px",
					borderRadius: Scale.XYpx(25),
					height: Scale.H(340) + "px",
					backgroundImage: resourceManager.Get<ImageResource>(ResourceIdentifier.Global.Add([this.nameGame, "paytable", "background-left"]).Scope()).CssBackground(),
					backgroundSize: "cover",
					backgroundRepeat: "no-repeat",
					backgroundPosition: "center",
					position: "relative",
				}
			});

			// Middle Group 
			if (this.NameGroups[IndexGroup] == "TopCenter" || this.NameGroups[IndexGroup] == "MiddleCenter" || this.NameGroups[IndexGroup] == "BottomCenter") {
				symbolContainer.style.backgroundImage = resourceManager.Get<ImageResource>(ResourceIdentifier.Global.Add([this.nameGame, "paytable", "background-center"]).Scope()).CssBackground()
				symbolContainer.style.justifyContent = "center";
				symbolContainer.style.width = "100%";
				symbolContainer.style.height = Scale.Wpx(250);
				symbolContainer.style.backgroundSize = "100% 100%";
			}

			//create title type for symbols container 
			let titleSymbolType = CreateElement("div", {
				classes: ["symbol-container-titleSymbolType", `${this.NameGroups[groupIndex]}`],
				style: {
					display: "flex",
					position: "absolute",
					top: Scale.Ypx(-30),
					width: "100%",
					height: "28%",
					alignItems: "center",
					justifyContent: "center",
				}
			});

			let textBackgroundSymbolType = CreateElement("div", {
				classes: ["textBackgroundSymbolType"],
				parentToAppend: titleSymbolType,
				style: {
					display: "flex",
					width: "50%",
					height: "100%",
					alignItems: "center",
					justifyContent: "center",
					backgroundPosition: "center",
					backgroundSize: "contain",
					backgroundRepeat: "no-repeat",
				}
			});

			//add title if its enable wild or Scatter
			if (slotSymbol.SymbolType == "Scatter") {
				symbolContainer.appendChild(titleSymbolType);
				textBackgroundSymbolType.style.backgroundImage = resourceManager.Get<ImageResource>(ResourceIdentifier.Global.Add(["paytableTitle", "scatter"]).Scope()).CssBackground();				//textSymbolType.textContent = "SCATTER";
			}
			else if (slotSymbol.SymbolType.includes("Wild")) {
				let GroupData = this.paytable.Groups[this.NameGroups[IndexGroup]];

				let wildSlideParams: WildBulkSlidePaytableParams = {
					translator: this.translator,
					wildSymbol: this.wildSymbol,
					wildInReel: this.wildInReel,
					scattersTrigger: this.scattersTrigger,
					resid: this.resid,
					groupData: GroupData,
					slotSymbolsData: this.slotSymbolsData,
					//symbolSpriteAnims: null,
					playWindow: this.playWindow,
					systemContext: this.systemContext,
					playlines: this.playlines,
					symbolsCollection: this.symbolsCollection,
				}
				//create slide for wild
				this.wildBulkSlide = new WildBulkSlide(wildSlideParams);
				symbolContainer.appendChild(this.wildBulkSlide.View());
				this.wildBulkSlide.ResourcesLoaded(resourceManager);

				mainSymbolContainer.style.height = Scale.Hpx(340);
				symbolContainer.style.height = Scale.Wpx(340);
				textBackgroundSymbolType.style.backgroundImage = resourceManager.Get<ImageResource>(ResourceIdentifier.Global.Add(["paytableTitle", "wild"]).Scope()).CssBackground();
				symbolContainer.appendChild(titleSymbolType);
			}

			//create title type for symbols container 
			let descriptionContainerSymbolType = CreateElement("div", {
				classes: ["symbol-container-descriptionContainerSymbolType", `${this.NameGroups[groupIndex]}`],
				style: {
					display: "flex",
					position: "absolute",
					//bottom: Scale.Ypx(-22),
					width: "100%",
					height: "80%",
					alignItems: "end",
					justifyContent: "center",
				}
			});

			let descriptiontextSymbolType = CreateElement("div", {
				classes: ["descriptiontextSymbolType"],
				parentToAppend: descriptionContainerSymbolType,
				style: {
					display: "inline-flex",
					width: "100%",
					//height: "100%",
					//alignItems: "center",
					justifyContent: "center",
					fontWeight: "bold",
					//verticalAlign: "middle",
					textShadow: `0px 0px ${Scale.fhpx(5)} black,0px 0px ${Scale.fhpx(10)} black,0px 0px ${Scale.fhpx(15)} black,0px 0px ${Scale.fhpx(40)} black`,
					color: "white",
					fontSize: Scale.fhpx(20),
					textAlign: "center",
					lineHeight: Scale.fhpx(25),
				}
			});

			//add description if its enable wild or Scatter
			if (slotSymbol.SymbolType == "Scatter") {
				let scatterData = this.bonusTrigger?.find(symbol => symbol.RequiredSymbols.includes(slotSymbol.Index));
				if (scatterData) {
					symbolContainer.appendChild(descriptionContainerSymbolType);
					descriptiontextSymbolType.style.fontSize = Scale.fhpx(18);
					let translatedMessage = this.translator.Translate(() => this.translator.t.scatterBonusPaytableMessage(scatterData));
					descriptiontextSymbolType.appendChild(translatedMessage.location);
				}
			}
			// else if (slotSymbol.SymbolType.includes("Wild")) {}

			let symbols: string[];
			//create symbol container 
			let imgContainer = CreateElement("div", {
				classes: ["img-container",],
				parentToAppend: symbolContainer,
				style: {
					width: "60%",
					display: "flex",
					flexDirection: "column",
					position: "relative",
					//top:Scale.Ypx(-32),
				}
			});


			//move position for put all div more near the others
			if (this.NameGroups[IndexGroup] == "TopLeft" || this.NameGroups[IndexGroup] == "TopRight") {
				symbolContainer.style.bottom = Scale.Ypx(-120);
			}
			else if (this.NameGroups[IndexGroup] == "MiddleLeft" || this.NameGroups[IndexGroup] == "MiddleRight") {
				symbolContainer.style.bottom = Scale.Ypx(-73);
			}
			else if (this.NameGroups[IndexGroup] == "BottomLeft" || this.NameGroups[IndexGroup] == "BottomRight") {
				symbolContainer.style.bottom = Scale.Ypx(-19);
			}

			//check if group are null or not 
			if (this.paytable.Groups[this.NameGroups[IndexGroup]].Symbols != null) {

				symbols = this.paytable.Groups[this.NameGroups[IndexGroup]].Symbols;
				
				//Now will add slider for wild grup 

				if (symbols.includes("Wild") != true) {
					//will works ok if dont have wild on that group
					//create symbols
					for (let index = 0; index < symbols.length; index++) {

						let symbol = CreateElement("div", {
							classes: ["symbol", "paytable-symbol-" + symbol_number.toString()],
							parentToAppend: imgContainer,
							style: {
								display: "flex",
								flexDirection: "column",
							}
						});

						let PaytableSymbolImage = CreateElement("div", {
							classes: ["paytable-symbol-image", "image"],
							parentToAppend: symbol,
							style: {
								alignItems: "center",
								justifyContent: "center",
								position: "relative",

							}
						});

						// if you have 1 symbols per group 
						if (symbols.length == 1) {
							this.symbolSize = new Size(Scale.W(400), Scale.H(350));
							//position symbol
							if (this.NameGroups[IndexGroup] == "TopCenter" || this.NameGroups[IndexGroup] == "MiddleCenter" || this.NameGroups[IndexGroup] == "BottomCenter") {
								this.symbolSize = new Size(Scale.W(320), Scale.H(280));
								imgContainer.style.left = Scale.Ypx(-80);
								imgContainer.style.top = Scale.Ypx(-40);
							}
							else if (this.NameGroups[IndexGroup] == "TopLeft" || this.NameGroups[IndexGroup] == "MiddleLeft" || this.NameGroups[IndexGroup] == "BottomLeft") {
								imgContainer.style.left = Scale.Ypx(-100);
								imgContainer.style.top = Scale.Ypx(-71);
							}
							else if (this.NameGroups[IndexGroup] == "TopRight" || this.NameGroups[IndexGroup] == "MiddleRight" || this.NameGroups[IndexGroup] == "BottomtRight") {
								imgContainer.style.left = Scale.Ypx(100);
								imgContainer.style.top = Scale.Ypx(-71);
							}
						}
						//if you have 2 symbols per group 						
						else if (symbols.length == 2) {
							//change size when you have 2 symbols at same group
							this.symbolSize = new Size(Scale.W(350), Scale.H(300));
							symbol.style.justifyContent = "center";
							symbol.style.position = "relative";
							symbol.style.height = "20%";
							imgContainer.style.top = Scale.Ypx(15);

							if (index == 1) {
								symbol.style.left = Scale.Xpx(30);
							}

							//aling right img items						
							if (this.NameGroups[IndexGroup] == "TopRight" || this.NameGroups[IndexGroup] == "MiddleRight" || this.NameGroups[IndexGroup] == "BottomRight") {
								imgContainer.style.left = Scale.Ypx(110);
								if (index == 1) {
									symbol.style.left = Scale.Xpx(-80);
								}
							} else {
								//aling left img items
								imgContainer.style.left = Scale.Ypx(-110);
							}
						}

						symbol_number++;						
						//create symbol 
						//let canvas: MyCanvas = new MyCanvas(this.symbolSize);
						//this.canvas.push(canvas);
						let imgHTML = this.symbolsCollection.get("Symbol_"+symbols[index]).imgResource.cloneNode(true) as HTMLSpanElement;
						imgHTML.style.width = this.symbolSize.Width + "px";
						imgHTML.style.height = this.symbolSize.Height + "px";
						
						PaytableSymbolImage.appendChild(imgHTML);

						console.log("SymbolsCollection-Search:",symbols[index]);
					}



					//create combination per group
					let paytableCombinations = CreateElement("div", {
						classes: ["paytable-combinations"],
						parentToAppend: symbolContainer,
						style: {
							display: "flex",
							flexDirection: "column",
							justifyContent: "center",
							fontFamily: "Arial",
							fontWeight: "normal",
							position: "absolute",
							lineHeight: Scale.fhpx(60),
							textAlign: "left",
							height: "100%",
							marginRight: Scale.Xpx(20),
						}
					});

					if (this.NameGroups[IndexGroup] == "TopLeft" || this.NameGroups[IndexGroup] == "MiddleLeft" || this.NameGroups[IndexGroup] == "BottomLeft") {
						paytableCombinations.style.right = Scale.Xpx(30);
						paytableCombinations.style.marginRight = Scale.Xpx(20);
						if (this.NameGroups[IndexGroup] == "MiddleLeft") {
							//change background for right position
							symbolContainer.style.backgroundImage = resourceManager.Get<ImageResource>(ResourceIdentifier.Global.Add([this.nameGame, "paytable", "background-right"]).Scope()).CssBackground();
						}
					}
					else if (this.NameGroups[IndexGroup] == "TopRight" || this.NameGroups[IndexGroup] == "MiddleRight" || this.NameGroups[IndexGroup] == "BottomRight") {
						symbolContainer.style.flexDirection = "row-reverse";
						paytableCombinations.style.textAlign = "right";
						paytableCombinations.style.left = Scale.Xpx(50);
						paytableCombinations.style.marginLeft = Scale.Xpx(20);
						//use background for right position 						
						symbolContainer.style.backgroundImage = resourceManager.Get<ImageResource>(ResourceIdentifier.Global.Add([this.nameGame, "paytable", "background-right"]).Scope()).CssBackground();
						if (this.NameGroups[IndexGroup] == "MiddleRight") {
							//change background for left position
							symbolContainer.style.backgroundImage = resourceManager.Get<ImageResource>(ResourceIdentifier.Global.Add([this.nameGame, "paytable", "background-left"]).Scope()).CssBackground();
						}
					}
					else if (this.NameGroups[IndexGroup] == "TopCenter" || this.NameGroups[IndexGroup] == "MiddleCenter" || this.NameGroups[IndexGroup] == "BottomCenter") {
						paytableCombinations.style.lineHeight = Scale.fhpx(52);
						paytableCombinations.style.right = Scale.Xpx(30);
						paytableCombinations.style.marginRight = Scale.Xpx(20);
					}

					//let combinations = this.paytable[symbol_number].Combinations;
					for (let indexPays = 0; indexPays < this.paytable.Groups[this.NameGroups[IndexGroup]].Pays.length; indexPays++) {
						let paytableCombination = CreateElement("div", {
							classes: ["paytable-combination-" + indexPays],
							parentToAppend: paytableCombinations,
							style: {
								display: "flex",
								flexDirection: "row",
								fontWeight: "bold",
								verticalAlign: "middle",
								textShadow: `0px 0px ${Scale.fhpx(5)} black,0px 0px ${Scale.fhpx(10)} black,0px 0px ${Scale.fhpx(15)} black,0px 0px ${Scale.fhpx(40)} black`,
								flexShrink: "2",
								position: "relative",
								alignItems: "center",
							}
						});

						let paytableOcurrence = CreateElement("div", {
							classes: ["paytable-occurence"],
							parentToAppend: paytableCombination,
							style: {
								fontSize: Scale.fhpx(50),
								color: " #f49b42",
								textAlign: "left",
							}
						});

						paytableOcurrence.innerText = this.paytable.Groups[this.NameGroups[IndexGroup]].Pays[indexPays].Count.toString() + "x";

						// this is win, this updates
						let paytableRewad = CreateElement("div", {
							classes: ["paytable-reward"],
							parentToAppend: paytableCombination,
							style: {
								fontSize: Scale.fhpx(Math.max(50 - (indexPays * 7), 30)),
								color: " white",
								textAlign: "center",
								flexGrow: "1",
							}
						});



						let symbolNames: string[] = this.paytable.Groups[this.NameGroups[IndexGroup]].Symbols;
						let symbolType: SymbolType = this.slotSymbolsData.find(symbol => symbol.ID == symbolNames[0]).SymbolType;

						this.winsToUpdate.push({
							symbolType: symbolType,
							groupName: this.NameGroups[IndexGroup],
							payIndex: indexPays,
							winElement: paytableRewad
						});
						paytableRewad.innerText = " " + this.paytable.Groups[this.NameGroups[IndexGroup]].Pays[indexPays].WinCredits.toString();
					}
				}
			}
			IndexGroup++;
		}

		//append view paytable container 
		this.view.appendChild(paytableSymbolsContainer);

		this.numberGroups = IndexGroup;
		this.numerSymbols = symbol_number;
	}

	//set bet 
	public SetBet(message: SlotGameMessages.BetChange) {
		let totalBet = message.betTotalCredit;
		let factor = totalBet/this.paytable.PaytableForBetCredits;

		//for (let [symbolIndex, el] of this.winsToUpdate)
		for (let s = 0; s < this.winsToUpdate.length; s++)
		{
			let winToUpdate = this.winsToUpdate[s];
			// if scatter, calculate different

			let win: number = 0;
			if (winToUpdate.symbolType == "Scatter")
			{
				win = this.paytable.Groups[winToUpdate.groupName].Pays[winToUpdate.payIndex].WinCredits * totalBet;
			}
			else
			{
				win = this.paytable.Groups[winToUpdate.groupName].Pays[winToUpdate.payIndex].WinCredits * factor;
			}

			winToUpdate.winElement.innerText = win.toString();
			//console.log(win.toString());
		}
	}

	//anim symbol paytable
	public Update(force: boolean = false): void {		
		// this.titleSprite?.Update();
		this.wildBulkSlide?.Update();
	}
	public View(): HTMLElement {
		return this.view;
	}

	//start titleAnim timer
	public StartAnim() {
		// this.titleStartTimer?.Start();
		this.wildBulkSlide?.StartAnim();
	}

	//stop titleAnim timer 
	public StopAnim() {
		// this.titleStartTimer?.Stop();
		this.wildBulkSlide?.StopAnim();
	}
}

